import theme from '../../theme/news12'
import redesignedTheme from '../../theme/news12-redesign'

import { createGlobalStyle } from 'styled-components'

const BaseCSS = createGlobalStyle`
    h1, h2, h3, h4, h5, h6 {
        font-weight: bold;
    }
    
    html {
        font-size: 16px;
    }

    html, body {
        margin: 0;
        font-family: Graphik, sans-serif;
        box-sizing: border-box;
        min-width: 375px;
        height: 100%;
    }

    body {
        font-size: 1.125rem;
    }

    @media only screen and (max-width: 375px) {
        html, body {
            min-width: 0;
        }
    }

    h1, h2, h3, h4, h5, h6 {
        color: ${theme.colors.mineShaft};
        border-bottom: 2px solid ${redesignedTheme.colors.lightBlue};
        font-size: 1.65em;
        width: 100%;
        margin: 0;
        padding: 0 0 6px 0;
    }

    h2 {
        font-size: 1.45em;
    }

    h3 {
        font-size: 1.3em;
    }

    h4, h5, h6 {
        font-size: 1.22em;
        text-transform: uppercase;
        width: fit-content;
    }

    img {
        max-width: 100%;
        vertical-align: middle;
    }

    a {
        text-decoration: none;
        color: ${theme.colors.royalBlue};
        font-weight: 600;
    }

    @media only screen and (max-width: 1024px) {
        h4, h5, h6 {
            display: block;
            margin: 0 auto;
            text-transform: uppercase;
            text-align: center;
        }
    }

    @media only screen and (max-width: 767px) {
        h1, h2, h3 {
            display: block;
            margin: 0 auto;
            text-transform: uppercase;
            text-align: center;
            font-size: 1.22em;
        }

        h4, h5, h6 {
            font-size: 1.11em;
        }

        h1 {
            width: fit-content;
        }
    }
`

export default BaseCSS
